export default __webpack_public_path__ + "static/media/garlands1.67f9a3d1.png";